import { useState, useCallback } from 'react';
import { pwd212Api, FD130, FD132 } from '../../../services/pwd212Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master + product_desc */
  const resolveAllNames = useCallback(async (data: Partial<FD130>, prodDesc?: Partial<FD132>) => {
    const entries: [string, string, string][] = [
      ['processor', 'company', data.fd130_12 || ''],       // 加工廠
      ['currency', 'currency', data.fd130_45 || ''],
      ['paymentTerms', 'paymentTerms', data.fd130_471 || ''],
      ['tradeTerms', 'tradeTerms', data.fd130_47 || ''],
      ['packing', 'packing', data.fd130_16a || ''],
      ['qcPerson', 'employee', data.fd130_27 || ''],
      ['entryPerson', 'employee', data.fd130_33 || ''],
      ['processingFee', 'processingFeeCode', data.fd130_15 || ''],
      ['remarkTemplate', 'remarkTemplate', data.fd130_411 || ''],
      ['sampleReq', 'sampleRequirement', data.fd130_35 || ''],
    ];
    if (prodDesc) {
      entries.push(
        ['purchaser', 'employee', prodDesc.fd132_15 || ''],
      );
    }
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        pwd212Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await pwd212Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, setNames, resolveAllNames, resolveSingleName, clearNames };
}
